import { Injectable } from '@angular/core';
import { RestProviderService } from './rest-provider.service';
import { SharedService } from './shared.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ConstantesService } from './constantes.service';

@Injectable()
export class AuthService {
  usuarioActual: Subject<any> = new Subject();
  constructor(
    private restProvider: RestProviderService,
    private sharedService: SharedService,
    private constantes: ConstantesService,
    private router:Router
  ) { }

  public logIn(username: string, password: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = {
        data: {
          numeroDocumento: username,
          password: password
        }
      }
      this.restProvider.executeHttpMethod("/lc/au", params).subscribe(
        (result: any) => {
            if (result.sessionKey) {
              this.sharedService.sessionKey = result.sessionKey;
              this.sharedService.userSession = result.data;
              sessionStorage.setItem('SESSION_KEY', this.sharedService.sessionKey);
              let sessionUser: any = JSON.parse(JSON.stringify(this.sharedService.userSession));
              sessionStorage.setItem('SESSION_USER', JSON.stringify(sessionUser));
              resolve(true);
            } else {
              resolve(false);
            }
        },
        error => {
          console.error(error);
          reject(error);
        });
    });
  }

  public logOut(): void {
    this.restProvider.executeHttpMethod("/lc/lu", {}).subscribe(
      result => {
            this.sharedService.sessionKey = '';
            this.sharedService.userSession = undefined;
            this.sharedService.menuItems = [];
            this.sharedService.planSession = undefined;
            this.sharedService.abrirSidebarObjetivos=false;
            this.sharedService.destroySubjects();
            sessionStorage.clear();
          setTimeout(() => {
            this.router.navigate(['dashboard/lac'], { skipLocationChange: true });
            window.location.href = '/MINC-PNLOTI/';
          }, 2000);
      },
      error => {
        console.error(error);
      });
  }

  public validateSession(): void {
    if (sessionStorage.getItem('SESSION_USER') && sessionStorage.getItem('SESSION_USER') != '' && sessionStorage.getItem('SESSION_USER') != 'undefined') {
      this.sharedService.sessionKey = sessionStorage.getItem('SESSION_KEY');
      let sessionUser: any = JSON.parse(sessionStorage.getItem('SESSION_USER'));
     this.logIn(sessionUser.numeroDocumento,sessionUser.password).then(()=>{
       this.goHome();
     })
    }
  }

  public goHome(){
    if(!this.sharedService.planSession){
      let plan =  sessionStorage.getItem('PLAN_SELECCIONADO');
      if(plan!=undefined && plan != ''){
        let planSelect:any=JSON.parse(plan);
        this.sharedService.planSession=planSelect
      }
    }
    if(this.sharedService.planSession){
      let params = {
        data: {
          plan: {
            id: this.constantes.ID_PLAN_PNLOTI
          }
        }
      };
      this.restProvider.executeHttpMethod("/cpc/bpip", params).subscribe((result: any) => {
        this.sharedService.planSession.listaConfiguracionPlan = result.datalist;
        let params = {
          data: {
            id: this.constantes.ID_CATALOGO_LIMITE_SEMAFORO
          }
        }
        this.restProvider.executeHttpMethod("/cdc/bic", params).subscribe((result: any) => {
         let listaValoresSemaforo:any[]=result.datalist;
         this.sharedService.limiteRojo=listaValoresSemaforo[0].valorAuxiliar;
         this.sharedService.limiteAmbar=listaValoresSemaforo[1].valorAuxiliar;
         if(!(this.sharedService.userSession && this.sharedService.userSession.id)){
          this.router.navigate(["dashboard/lac"], { skipLocationChange: true });
        }else{
          this.router.navigate(["dashboard/lc"], { skipLocationChange: true });
        }
        });
      });
    }else{
      this.router.navigate([''], { skipLocationChange: true });
    }
  }

}
